import { useLang } from "../lib/i18n";

const STATUS_STYLES = {
  HEALTHY: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]",
  WATCH: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  AT_RISK: "bg-[#FFEDD5] text-[#9A3412] border-[#FED7AA]",
  CRITICAL: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
  INSUFFICIENT_DATA: "bg-[#F1F5F9] text-[#334155] border-[#E2E8F0]",
  DUE: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
  DRAFT: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  SUBMITTED_ON_TIME: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]",
  SUBMITTED_LATE: "bg-[#FFEDD5] text-[#9A3412] border-[#FED7AA]",
  MISSING: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
  EXEMPT: "bg-[#F1F5F9] text-[#334155] border-[#E2E8F0]",
  NOT_REQUIRED: "bg-[#F1F5F9] text-[#334155] border-[#E2E8F0]",
  NEW: "bg-[#FEE2E2] text-[#991B1B] border-[#FECACA]",
  ACKNOWLEDGED: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
  IN_PROGRESS: "bg-[#DBEAFE] text-[#1E40AF] border-[#BFDBFE]",
  RESOLVED: "bg-[#DCFCE7] text-[#166534] border-[#BBF7D0]",
  OVERRIDDEN: "bg-[#F1F5F9] text-[#334155] border-[#E2E8F0]",
  REOPENED: "bg-[#FFEDD5] text-[#9A3412] border-[#FED7AA]",
};

const SEVERITY_STYLES = {
  CRITICAL: "bg-[#991B1B] text-white border-[#991B1B]",
  HIGH: "bg-[#EA580C] text-white border-[#EA580C]",
  MEDIUM: "bg-[#FEF3C7] text-[#92400E] border-[#FDE68A]",
  LOW: "bg-[#F1F5F9] text-[#334155] border-[#E2E8F0]",
  INFO: "bg-[#E0E7FF] text-[#3730A3] border-[#C7D2FE]",
};

export function StatusBadge({ status, testId }) {
  const { t } = useLang();
  if (!status) return null;
  return (
    <span
      data-testid={testId || `status-badge-${status.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${STATUS_STYLES[status] || STATUS_STYLES.INSUFFICIENT_DATA}`}
    >
      {t(`statuses.${status}`)}
    </span>
  );
}

export function SeverityBadge({ severity, testId }) {
  const { t } = useLang();
  if (!severity) return null;
  return (
    <span
      data-testid={testId || `severity-badge-${severity.toLowerCase()}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold border ${SEVERITY_STYLES[severity] || SEVERITY_STYLES.LOW}`}
    >
      {t(`severity.${severity}`)}
    </span>
  );
}

export function healthColor(status) {
  switch (status) {
    case "HEALTHY":
      return "#16A34A";
    case "WATCH":
      return "#D97706";
    case "AT_RISK":
      return "#EA580C";
    case "CRITICAL":
      return "#DC2626";
    default:
      return "#64748B";
  }
}
